import { connectAPI } from "./api"
import { IContent } from "../components/tutorial"

export const getContent = (): Promise<IContent> => {
    const match = window.location.pathname.match(
        /\/((dashboard|workspace).*?)\/tutorial/,
    )
    if (match) {
        const urlpart = match[1]
        return connectAPI.getJSON("tutorial/contentfor" + urlpart)
    } else {
        throw new Error("Invalid URL")
    }
}
